import { type ReactNode } from 'react';
import { convert } from '../function/convert';
interface Props<T, V> {
  value: T;
  formatter: (value: NonNullable<T>) => V;
  defaultValue?: ReactNode;
}
export function Convert<T, V extends ReactNode>({
  value,
  formatter,
  defaultValue
}: Props<T, V>): ReactNode {
  return convert(value, formatter) ?? defaultValue;
}